import {LogoImg, NavigationContainer, NavigationWrapper,NavigationLinks,
	NavigationContacts , NavigationLinksContainer, Phone, SocialLinks} from './navigation.styles'
import Logo  from '../../assets/logo/logo.png';
import Language from '../language/language.component';
import phone from '../../assets/icons/phone.svg'
import telegram from '../../assets/icons/telegram.svg';
import whatsap from '../../assets/icons/whatsapp.svg';
import viber from '../../assets/icons/viber.svg';
import { Link } from 'react-scroll';

const setHash = (id) => {
	window.history.replaceState(null, "", `${window.location.pathname}#${id}`);
};

const Navigation =({props})=>{
	return(
		<NavigationWrapper>
			<NavigationContainer>
				<Link className='logoContainer' to="home" spy={true} smooth={true} offset={0} duration={500} onClick={() => setHash("home")}>
					<LogoImg src={Logo} alt='main-logo' className="logo"/>
				</Link>
				<NavigationLinksContainer>
					<NavigationLinks>
						<ul>
							<li><Language/></li>
							<li><Link to="why-us" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHash("why-us")}>{props[1]}</Link></li>
							<li><Link to="about-us" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHash("about-us")}>{props[2]}</Link></li>
							<li><Link to="services" spy={true} smooth={true} offset={-250} duration={500} onClick={() => setHash("services")}>{props[3]}</Link></li>
							<li><Link to="contacts" spy={true} smooth={true} offset={0} duration={500} onClick={() => setHash("contacts")}>{props[4]}</Link></li>
						</ul>
					</NavigationLinks>
					<NavigationContacts>
						<Phone>
							<a href="tel:+37369107497">
								<img src={phone} alt="" />
								<span>069 107 497</span> 
							</a>
						</Phone>
						<SocialLinks>
							<a href="viber://chat?number=%2B37369107497"><span className='viber'><img src={viber} alt="" /></span></a>
							<a href="https://telegram.me/+37369107497"><span className='telega'><img src={telegram} alt="" /></span></a>
							<a href="https://wa.me/+37369107497" ><span className='whatsap'><img src={whatsap} alt="" /></span></a>
						</SocialLinks>
					</NavigationContacts>
				</NavigationLinksContainer>
			</NavigationContainer>
		</NavigationWrapper>
	)
}
export default Navigation;